import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import * as React from 'react';

const BloodPressureForm = ({ formData }: IOwnProps): React.JSX.Element => (
  <React.Fragment>
    <FormRow title="general.date">
      <InputHandler
        type="PartialDate"
        editing={true}
        name="date"
        formData={formData}
        dateDefault="now"
        isNotCancellable={true}
      />
    </FormRow>
    <FormRow title="clinicalstudy.bloodPressureSystolic">
      <InputHandler
        type="NumberField"
        editing={true}
        name="bloodPressureSystolic"
        formData={formData}
        placeholder="clinicalstudy.bloodPressurePlaceholder"
      />
    </FormRow>
    <FormRow title="clinicalstudy.bloodPressureDiastolic">
      <InputHandler
        type="NumberField"
        editing={true}
        name="bloodPressureDiastolic"
        formData={formData}
        placeholder={'clinicalstudy.bloodPressurePlaceholder'}
      />
    </FormRow>
  </React.Fragment>
);

interface IOwnProps {
  formData: IFormData<IDocumentWithTypeV2<'bloodPressure'>>;
}

export default BloodPressureForm;
